module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAYAAAADU1RxAAAAQElEQVRIx2P8DwQMAwwYRx0x6ohB6Yi+C/uPDbgjGKbl/R91xKgjRh2BzRHbzBUGPoteUxP6P+qIUUeMOgILAAAvtzUTyoSCcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/bg.png
// module id = 781
// module chunks = 0